import {DesignerThicknessReducerActions, DesignerThicknessType} from '@mgp-fe/designer/state/domain';

export function thicknessReducer(state: DesignerThicknessType, action: DesignerThicknessReducerActions) {
	const {thickness} = action;
	const temp = state;

	temp.thickness = thickness;

	return temp;
}